//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'CentorMcIsaac',
  data() {
    return {
      defaultJson:{
        "(Risk of strep. infection 51%-53%)": "（链球菌感染风险 51% - 53%）",
        "Tonsillar swelling\/exudates": "扁桃体肿大 \/ 渗出",
        "Fever": "发热",
        "3-14 yr": "3 - 14 岁",
        "Age is only used in McIsaac": "年龄仅用于 McIsaac 评分",
        "feverHint": "> 38°C \/ > 100.4°F",
        "15-44 yr": "15 - 44 岁",
        "(Risk of strep. infection 5%-10%)": "（链球菌感染风险 5% - 10%）",
        "(Risk of strep. infection 15%)": "（链球菌感染风险 15%）",
        "(Risk of strep. infection 32%)": "（链球菌感染风险 32%）",
        "(Risk of strep. infection 56%)": "（链球菌感染风险 56%）",
        "(Risk of strep. infection 6.5%)": "（链球菌感染风险 6.5%）",
        "Absence of Cough": "无咳嗽",
        "Antibiotic if culture is positive": "培养阳性则应用抗菌素",
        "Tender anterior cervical adenopathy": "疼痛肿大的颈前淋巴结",
        "Treat empirically with antibiotic": "经验性抗菌素治疗",
        "≥45 yr": "≥ 45 岁",
        "(Risk of strep. infection 11%-17%)": "（链球菌感染风险 11% - 17%）",
        "(Risk of strep. infection 2.5%)": "（链球菌感染风险 2.5%）",
        "(Risk of strep. infection 28%-35%)": "（链球菌感染风险 28% - 35%）",
        "No antibiotic or throat culture": "不使用抗菌素或咽拭子培养",
        "Age": "年龄",
        "(Risk of strep. infection 1%-2.5%)": "（链球菌感染风险 1% - 2.5%）"
      },
      form:{
        tonsils:'0',
        lymphnodes:'0',
        fever:'0',
        cough:'0',
        age:''
      },
      hasScore:false,
      hasMcisaacScore:false,
      disabled:false,
      ageDEsc:'年龄仅用于 McIsaac 评分',
      dataList1:[
        {value:"1",name:'3 - 14 岁'},
        {value:"0",name:'15 - 44 岁'},
        {value:"-1",name:'≥ 45 岁'},
      ],
      mcisaac:'',
      centor:''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key] && key!='age') {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        // tonsils + lymphnodes + fever + cough
        // tonsils + lymphnodes + fever + cough + age
        let result = form.tonsils + form.lymphnodes + form.fever + form.cough
        let mcisaacScore = form.tonsils + form.lymphnodes + form.fever + form.cough + form.age
        self.hasScore = true
        self.centor = result
        self.mcisaac = mcisaacScore
        return String(result)
      }
    },
    mcisaacCcore() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          }else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasMcisaacScore = false
        return '0'
      } else {
        // tonsils + lymphnodes + fever + cough
        // tonsils + lymphnodes + fever + cough + age
        let mcisaacScore = form.tonsils + form.lymphnodes + form.fever + form.cough + form.age
        self.hasMcisaacScore = true
        self.mcisaac = mcisaacScore
        return String(mcisaacScore)
      }
    },
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/CentorMcIsaac.vue